import PublicShell from '../components/PublicShell.jsx';

/**
 * The signed-out front door.
 *
 * Previously arriving at the root with no session bounced straight to Entra.
 * When Entra then signed the browser in as an account the portal refuses, the
 * only way back was another bounce to the same account — the loop. A page with
 * a button makes signing in a deliberate act, so the user can choose a
 * different account instead of being shoved at one.
 *
 * Deep links still re-authenticate silently: someone following a link to a
 * report wants the report, not a landing page. Only the root stops here.
 */

const DEMO_URL = 'https://vizora.com/book-a-free-demo/';
const SITE_URL = 'https://vizora.com/';

export default function Landing() {
  /* Preserve where they were headed, so a session that expired mid-visit
     returns to the same place after signing in. */
  const params = new URLSearchParams(window.location.search);
  const returnTo = params.get('returnTo');
  const signInHref = returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')
    ? `/auth/signin?returnTo=${encodeURIComponent(returnTo)}`
    : '/auth/signin';

  return (
    <PublicShell
      eyebrow="Customer portal"
      heading="Your reporting team, without the overheads"
      lead="Live dashboards and the KPIs your operational software cannot produce, built and run for you."
    >
      <div className="public-actions">
        <a className="btn btn-primary btn-lg" href={signInHref}>Sign in</a>

        {/* Signing in with the wrong Microsoft account is the most common
            reason someone cannot get in, and silent SSO hides it. Offering the
            account picker here means they never have to discover /error. */}
        <a className="btn btn-link" href="/auth/signin?prompt=select_account">
          Use a different account
        </a>
      </div>

      <hr className="public-rule" />

      {/* Kept to two lines at 560px. Every line here is a line the buttons
          below move down by, and those buttons are the point of the page. */}
      <p className="public-pitch">
        <strong>Not a customer yet?</strong> Vizora is your outsourced BI team —
        connecting your systems and delivering the KPIs you actually need.
      </p>

      {/* Teal, not magenta. Magenta is what a customer does — Sign in, above.
          A second magenta button here would leave neither reading as the
          primary action. */}
      <div className="public-actions">
        <a className="btn btn-vz-teal" href="/demo">Try the demo</a>
        <a className="btn btn-vz-teal-outline" href={DEMO_URL}>Book a free demo</a>
        <a className="btn btn-link btn-vz-teal-link" href={SITE_URL}>vizora.com</a>
      </div>
    </PublicShell>
  );
}
